/**
 * Sprint V100 (17.09.2026) — QuickCheck-Refactor auf Likert-Skala.
 *
 * SINGLE SOURCE OF TRUTH gespiegelt aus /app/backend/content/quickcheck_v100.py.
 * Aenderungen an Fragen-Texten MUESSEN in beiden Dateien synchron passieren.
 */

export const LIKERT_LABELS = [
  "Trifft gar nicht zu",
  "Trifft eher nicht zu",
  "Teils/teils",
  "Trifft eher zu",
  "Trifft voll zu",
];

// Sprint V100.1 (17.09.2026) — UX-Framework-Alignment mit 20-Fragen-Test:
// Dieselben 5 Smiley-Optionen wie in DashboardTest, damit der User im Test-
// Erlebnis nicht zwischen zwei Design-Sprachen hin- und herwechselt.
// (Backend-Semantik unveraendert: value 1..5 wird nach POINTS 0..4 gescored.)
export const LIKERT_OPTIONS = [
  { value: 1, smiley: "😞", label: "Nein, trifft nicht zu." },
  { value: 2, smiley: "🙁", label: "Eher nicht." },
  { value: 3, smiley: "😐", label: "Teils/teils." },
  { value: 4, smiley: "🙂", label: "Eher ja." },
  { value: 5, smiley: "😄", label: "Ja, trifft zu 100 %." },
];

export const QUICKCHECK_V100 = {
  beruflich: [
    {
      qid: 1,
      measures: "eule",
      text:
        "Im nächsten Team-Meeting schlägt jemand eine neue Lösung für ein " +
        "Problem vor. Du überlegst erst gründlich, ob das überhaupt sinnvoll " +
        "ist, bevor du reagierst.",
    },
    {
      qid: 2,
      measures: "hund",
      text:
        "Du übernimmst eine neue Aufgabe im Team. Es motiviert dich besonders, " +
        "wenn andere sehen und anerkennen, was du tust.",
    },
    {
      qid: 3,
      measures: "katze",
      text:
        "Dein Vorgesetzter gibt dir eine klare Anweisung zu etwas, das du " +
        "anders lösen würdest. Auch wenn die Anweisung vernünftig klingt — " +
        "innerlich sträubst du dich.",
    },
    {
      qid: 4,
      measures: "biene",
      text:
        "Du bekommst eine neue Projektaufgabe mit klarer Anleitung. Sobald du " +
        "verstanden hast was zu tun ist und wie es geht — legst du sofort los.",
    },
    {
      qid: 5,
      measures: "trennschaerfe_kbh",
      text:
        "Freitagabend, kurz vor Feierabend — dein Chef bittet dich, am " +
        "Samstagmorgen um acht eine Präsentation zu halten. Du sagst ehrlich, " +
        "dass dir das zu früh ist.",
    },
  ],
  privat: [
    {
      qid: 1,
      measures: "eule",
      text:
        "Dein Partner / deine Partnerin schlägt am Sonntag spontan vor, die " +
        "Eltern zum Essen einzuladen. Du überlegst erst gründlich, ob das " +
        "überhaupt sinnvoll ist, bevor du reagierst.",
    },
    {
      qid: 2,
      measures: "hund",
      text:
        "Du engagierst dich in einem Verein oder einer Nachbarschafts" +
        "initiative. Es motiviert dich besonders, wenn andere sehen und " +
        "anerkennen, was du tust.",
    },
    {
      qid: 3,
      measures: "katze",
      text:
        "Eine Freundin / ein Freund gibt dir einen gut gemeinten Tipp zu " +
        "etwas, das du längst entschieden hast. Auch wenn der Tipp vernünftig " +
        "klingt — innerlich bleibst du bei deiner Linie.",
    },
    {
      qid: 4,
      measures: "biene",
      text:
        "Du sollst dich um eine neue Sache kümmern — Versicherung, Steuer" +
        "erklärung oder Umzug. Sobald du verstanden hast was zu tun ist und " +
        "wie es geht — legst du sofort los.",
    },
    {
      qid: 5,
      measures: "trennschaerfe_kbh",
      text:
        "Samstagmorgen, acht Uhr — ein Freund ruft an und fragt, ob du " +
        "spontan beim Umzug helfen kannst. Du sagst ehrlich, dass dir das zu " +
        "früh ist.",
    },
  ],
};

export const FOKUSTYP_NAMES = {
  eule: "Eule",
  biene: "Biene",
  katze: "Katze",
  hund: "Hund",
};

export const FOKUSTYP_ICONS = {
  eule: "/icons/icon-eule.png",
  biene: "/icons/icon-biene.png",
  katze: "/icons/icon-katze.png",
  hund: "/icons/icon-hund.png",
};

export const FOKUSTYP_TAGLINES = {
  eule: "Du beobachtest, bevor du reagierst.",
  biene: "Du legst los, sobald du den Plan hast.",
  katze: "Du entscheidest selbst — auch gegen den Strom.",
  hund: "Du bist da, wenn andere dich brauchen.",
};
